<template>
  <section
    class="app-content"
    :class="{ expanding: expanding }"
    :style="{ left: left + 'px' }"
  >
    <!-- <page-header @expand="expand"></page-header> -->
    <router-view class="page-container" id="page-container"></router-view>
    <div class="footer-wrapper">
      <xp-footbar></xp-footbar>
    </div>
  </section>
</template>

<script>
import XpFootbar from '@xpeng/footbar'
import PageHeader from './header'
import KeepAliveView from './router-view'
import cookie from 'js-cookie'
import Config from '@/config'

export default {
  name: 'AppContent',
  props: {
    left: {
      type: Number,
      default: null
    }
  },
  components: {
    PageHeader,
    XpFootbar,
    KeepAliveView
  },
  data() {
    return {
      expanding: false
    }
  },
  mounted() {
    if (Config.EXPAND_CONTENT_DEFAULT) {
      this.expanding = true
    } else {
      this.expanding = Boolean(cookie.get('__content_expanding') === '1')
    }
    this.toggleSidebar()
  },
  methods: {
    expand() {
      this.expanding = !this.expanding
      this.expanding
        ? cookie.set('__content_expanding', '1')
        : cookie.set('__content_expanding', '0')
      this.toggleSidebar()
    },

    toggleSidebar() {
      if (!this.expanding) {
        this.$store.commit('closeSidebar')
      } else {
        this.$store.commit('openSidebar')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.app-content {
  position: absolute;
  top: 60px;
  bottom: 0;
  right: 0;
  left: 200px;
  z-index: 100;
  padding-bottom: 60px;
  background: #fff;
  box-shadow:
    0 0 0 1px rgba(0, 0, 0, 0.05),
    0 4px 24px 2px rgba(0, 0, 0, 0.1);

  &.expanding {
    left: 64px;
  }

  .footer-wrapper {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
  }

  .page-container {
    position: absolute;
    width: 100%;
    top: 0;
    bottom: 30px;
    overflow-y: scroll;
  }
}
</style>
